import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x1f3134C3f3f8AdD904B9635acBeFC0eA0D0E1ffC"),
    {
      name: "Euler Unichain WETH",
      description:
        "A conservative WETH vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x54ff502df96CD9B9585094EaCd86AAfCe902d06A"),
    {
      name: "Euler Unichain wstETH",
      description:
        "A conservative wstETH vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xe36DA4Ea4D07E54B1029eF26A896A656A3729f86"),
    {
      name: "Euler Unichain weETH",
      description:
        "A conservative weETH vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x45b41B20B11cD2e71A6BF3021bdbc3F8aFEa5538"),
    {
      name: "Euler Unichain ezETH",
      description:
        "A conservative ezETH vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x59215f65cB2F5Ddf048eFA8136Fc2C19F9A6C416"),
    {
      name: "Euler Unichain rsETH",
      description:
        "A conservative rsETH vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x6eAe95ee783e4D862867C4e0E4c3f4B95AA682Ba"),
    {
      name: "Euler Unichain USDC",
      description:
        "A conservative USDC vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xD49181c522eCDB265f0D9C175Cf26FFACE64eAD3"),
    {
      name: "Euler Unichain USDT0",
      description:
        "A conservative USDT0 vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x5d2511C1EBc795F4394f7f659f693f8C15796485"),
    {
      name: "Euler Unichain WBTC",
      description:
        "A conservative WBTC vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x576f68B0395738AEF01811b8F8EeC25302829F1d"),
    {
      name: "Euler Unichain UNI",
      description:
        "A conservative UNI vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x7650D7ae1981f2189d352b0EC743b9099D24086F"),
    {
      name: "Euler Unichain sUSDC",
      description:
        "A conservative sUSDC vault collateralized by other vaults in the Euler Unichain cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x6Bc1f97f96Dd6834A86aCf412B77C9F464419436"),
    {
      name: "Euler Unichain LST WETH",
      description:
        "WETH vault collateralized by other vaults in the Euler Unichain LST cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xCF28A176021e6906C359d1777041245d9Fda076D"),
    {
      name: "Euler Unichain LST wstETH",
      description:
        "wstETH vault collateralized by other vaults in the Euler Unichain LST cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xe6806beA4eCDE065bB757c35032f2c625848D8e8"),
    {
      name: "Euler Unichain LST rsETH",
      description:
        "rsETH vault collateralized by other vaults in the Euler Unichain LST cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x25e2ef0f957B61cdd26BBE954AFD5806A9DaDe49"),
    {
      name: "Euler Unichain LST ezETH",
      description:
        "ezETH vault collateralized by other vaults in the Euler Unichain LST cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x218c9e961fC5f6c8280bA160365FAbe8A53Ec6E5"),
    {
      name: "AlphaGrowth rETH Unichain Vault",
      description: "A supply-only rETH vault managed by AlphaGrowth.",
      entity: "alphagrowth",
    },
  ],
  [
    getAddress("0x5ADAde21c703912547BFc8952fe1B52f09437E2A"),
    {
      name: "AlphaGrowth WETH Unichain Vault",
      description:
        "A borrowing-enabled WETH vault managed by AlphaGrowth, enabling leveraged strategies with rETH collateral.",
      entity: "alphagrowth",
    },
  ],
])
